import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient instance for TanStack Query
 * Configures default behavior for queries and mutations
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: how long data is considered fresh
      staleTime: 1000 * 60 * 5, // minutes
      // Cache time: how long inactive data stays in cache
      gcTime: 1000 * 60 * 10, // minutes
      // Retry configuration
      retry: 0,
      // Disable automatic refetching on window focus by default
      refetchOnWindowFocus: false,
      // Disable automatic refetching on reconnect by default
      refetchOnReconnect: false,
    },
  },
});

export const STALE_TIME_LIVE_VIEW = 1000 * 60 * 15;
